import styled from 'styled-components';
export const StyledTrayContainer = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
`;
export const StyledTray = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 100%;

  background-color: ${(props) => props.theme.colors.ui.primaryInverse};
  transform: ${(props) => (props.open ? 'none' : 'translateY(100%)')};

  transition-timing-function: ${(props) => props.theme.easing};
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: transform;
`;
//# sourceMappingURL=Tray.styles.js.map